import axios from 'axios';

import type {
  IUserGetFullUsersQuery,
  IUserGetFullUsersRequest,
  IUserGetFullUsersResponse,
} from '@/app-package';

const getFullUsers = async (params: IUserGetFullUsersQuery) => {
  const config: IUserGetFullUsersRequest = {
    url: '/user/full',
    method: 'get',
    params,
  };

  const { data } = await axios.request<IUserGetFullUsersResponse>(config);

  return data;
};

export default getFullUsers;
